module.exports = __webpack_public_path__ + "img/chapter__10_image_1.4620410b.jpg";